import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumbs } from "../../../Home/Breadcrumb"
import Confirm from "../../../../components/Confirm";
import { useEquipamiento } from "../../../../hooks/useEquipamiento";
import { Equipamiento } from "../../../../types/Equipamiento";
import { DocumentoEquipamiento, TipoDocumentoOpcion } from "../../../../types/DocumentoEquipamiento";
import SeccionEquipamiento from "./Equipamiento";
import SeccionTipoDocumento from "./TipoDocumento";
import { FormEquipamientoErrors, validarEquipamiento } from "../validaciones";

const equipamientoNuevo: Equipamiento = {
    id: 0,
    nombre: '',
    descripcion: '',
    activo: true,
}

// Alta (/equipamiento/nuevo), edición (/equipamiento/editar/:id) y visualización (…?action=view).
export const CrearEquipamiento = () => {
    const { guardarEquipamiento, buscarEquipamiento, buscarTiposDocumentoActivos } = useEquipamiento();
    const [equipamientoForm, setEquipamientoForm] = useState<Equipamiento>(equipamientoNuevo);
    const [documentos, setDocumentos] = useState<DocumentoEquipamiento[]>([]);
    const [tiposActivos, setTiposActivos] = useState<TipoDocumentoOpcion[]>([]);
    const [formErrors, setFormErrors] = useState<FormEquipamientoErrors>({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const toggle = () => setShowModal(!showModal);
    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const edit = id !== undefined;
    const view = edit && searchParams.get('action') === 'view';

    useEffect(() => {
        buscarTiposDocumentoActivos().then(setTiposActivos);
        if (id) {
            buscarEquipamiento(id).then((equipamiento) => {
                setEquipamientoForm(equipamiento);
                setDocumentos(equipamiento.documentos ?? []);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const handleGuardar = () => {
        const errores = validarEquipamiento(equipamientoForm);
        setFormErrors(errores);
        if (Object.keys(errores).length > 0) {
            return;
        }
        guardarEquipamiento(equipamientoForm, documentos)
            .then(() => {
                toast.success("Se guardó el Equipamiento correctamente");
                navigate('/equipamiento');
            })
            .catch((err) => toast.error(err?.response?.data?.message ?? "Hubo un error al guardar el Equipamiento"));
    }

    const handleCancelar = (e: React.MouseEvent) => {
        e.preventDefault();
        setShowModal(true);
    }

    const cancelar = () => {
        toggle();
        navigate('/equipamiento');
    }

    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={edit ? (view ? 'Vista' : 'Editar') : 'Nuevo'}
                            titlePage={view ? 'Vista Equipamiento' : 'Equipamiento'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                            nameSecond={'Equipamiento'}
                            urlSecond={'/equipamiento'}
                        />
                        <Confirm isOpen={showModal} toggle={toggle} title='Cancelar' yesFn={cancelar}>
                            <div className="form-horizontal">
                                <div className="row">
                                    <p>Desea salir sin guardar el Equipamiento?</p>
                                </div>
                            </div>
                        </Confirm>

                        <SeccionEquipamiento
                            equipamientoForm={equipamientoForm}
                            setEquipamientoForm={setEquipamientoForm}
                            errors={formErrors}
                            edit={edit}
                            view={view}
                        />

                        <SeccionTipoDocumento
                            documentos={documentos}
                            setDocumentos={setDocumentos}
                            tiposActivos={tiposActivos}
                            view={view}
                        />

                        <br />
                        <div className="text-center">
                            {!view &&
                                <>
                                    <button className="btn btn-secondary mx-2" onClick={handleCancelar}>Cancelar</button>
                                    <button className="btn btn-success mx-2" onClick={handleGuardar}>Guardar</button>
                                </>
                            }
                            {view &&
                                <button className="btn btn-secondary mx-2" onClick={() => navigate('/equipamiento')}>Volver</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
